import type { Styles } from '@adornis/ass/style.js';
import { XInput } from '@adornis/forms/x-input.js';
import { customElement } from 'lit/decorators.js';

/**
 * @customElement cr-input
 */
@customElement('cr-input')
export class ChromiumInput extends XInput {
  override styles(): Styles[] {
    return [
      ...super.styles(),
      {
        ':host([disabled])': { opacity: '.9', pointerEvents: 'none' },
      },
    ];
  }
}
